"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FormDesignerConstants = /** @class */ (function () {
    function FormDesignerConstants() {
    }
    FormDesignerConstants.CARD_IDENTITY_ATTRIBUTE = 'card_id';
    FormDesignerConstants.NESTED_CARD_IDENTITY_ATTRIBUTE = 'nested_card_id';
    FormDesignerConstants.CONTROLLERS_ROW_ID_ATTRIBUTE = 'form_row_id';
    FormDesignerConstants.NESTED_CARD_CONTROLLERS_ROW_ID_ATTRIBUTE = 'nested_form_row_id';
    FormDesignerConstants.UPPER_ROW_CONTAINER = 'controller-upper-container';
    FormDesignerConstants.LOWER_ROW_CONTAINER = 'controller-row-lower-container';
    FormDesignerConstants.CONTROLLER_TRASH_BIN = 'trash_bin';
    FormDesignerConstants.CONTROLLER_CONTENT = 'controller_content';
    FormDesignerConstants.CONTROLLERS_ROW_CONTAINER = 'controller-row-container';
    FormDesignerConstants.CARD_TRASH_BIN = 'card_trash_bin';
    FormDesignerConstants.CARDS_CONTAINER = 'cards-container';
    FormDesignerConstants.NESTED_CARDS_UPPER_ROW_CONTAINER = 'nested-card-upper-container';
    FormDesignerConstants.NESTED_CARDS_ROW_CONTAINER = 'nested-card-row-container';
    FormDesignerConstants.NESTED_CARDS_LOWER_ROW_CONTAINER = 'nested-card-lower-container';
    FormDesignerConstants.NEW_CARD_ID = 'card_type';
    FormDesignerConstants.NEW_NESTED_CARD_ID = 'nested_card_type';
    FormDesignerConstants.HEADER_TRASH_BIN = 'header-trash_bin';
    FormDesignerConstants.SUBWAYMAP_TRASH_BIN = 'subwaymap-trash_bin';
    FormDesignerConstants.HEADER_CONTAINER = 'header-container';
    FormDesignerConstants.SUBWAYMAP_CONTAINER = 'subwaymap-container';
    FormDesignerConstants.NEW_HEADERS = 'headers_type';
    FormDesignerConstants.NEW_SUBWAYMAPS = 'subwaymap_type';
    FormDesignerConstants.NEW_FIELD_CONTROLLER = 'field_node';
    FormDesignerConstants.NEW_PLUGGED_CONTROLLER = 'control_node';
    FormDesignerConstants.DROPPED_NESTED_CARD = 'dropped_nested_card';
    FormDesignerConstants.CONTROLLER_ID = 'controller_id';
    FormDesignerConstants.CARD_SCROLLER_TOP_ELEMENT = 'card-scroller-top';
    FormDesignerConstants.CARD_SCROLLER_BOTTOM_ELEMENT = 'card-scroller-bottom';
    FormDesignerConstants.CONTROLLER_SCROLLER_TOP_ELEMENT = 'scroller-top';
    FormDesignerConstants.CONTROLLER_SCROLLER_BOTTOM_ELEMENT = 'scroller-bottom';
    return FormDesignerConstants;
}());
exports.FormDesignerConstants = FormDesignerConstants;
//# sourceMappingURL=form-designer.constants.js.map